import FormActionTypes from '../constants/form_action_types';

import ExecuteLinkActionHandler from './action/execute_link_action_handler';
import ExecuteSearcherActionHandler from './action/execute_searcher_action_handler';
import ExecuteSubmitActionHandler from './action/execute_submit_action_handler';

export const execute = (action) => {
	const actionHandler = getActionHandler(action);
	return actionHandler.execute(action);
};

const getActionHandler = (action) => {
	switch(action.type) {
		case FormActionTypes.LINK:
			return ExecuteLinkActionHandler;
		case FormActionTypes.SEARCHER:
			return ExecuteSearcherActionHandler;
		case FormActionTypes.SUBMIT:
			return ExecuteSubmitActionHandler;
		default:
			return { execute: () => Promise.resolve() };
	}
};

export default {
	execute,
};
